export default __webpack_public_path__ + "static/media/swp-icon.724d1746.svg";